module.exports = __webpack_public_path__ + "static/screenshot-overview-874d8d23f9e071e115d12e2116569ead.png";